import React, { useContext } from "react";
import SectionBlock from "../../../../global/components/FeatureCard/SectionBlock";
import nvrSetupConfiguration from "../../../../assets/images/nvr/nvr-setup-configuration.png";
import channelManagementStreaming from "../../../../assets/images/nvr/channel-management-streaming.png";
import cameraRecordingControl from "../../../../assets/images/nvr/camera-recording-control.png";
import CatalogueBackground from "../../../../assets/images/download-cutsheet2.png";
import useSWR from "swr";
import DownloadSection from "../../../../lib/downloadSection";
import { fetcher } from "../../../../lib/apiConstants";
import { LoginContext } from "../../../../lib/loginContext";

const PAGE_X = "px-6 lg:px-[120px]";

const sections = [
  {
    image: nvrSetupConfiguration,
    label: "NVR Setup & Configuration",
    description:
      "Easily integrate any NVR by specifying type, ONVIF, RTSP/Data ports, and app address. Once configured, the NVR connects with associated channels and cameras for seamless video capture and live streaming. This structure ensures unified, scalable surveillance infrastructure across your security network.",
    imageLeft: true,
    imageBg: "#f8f8f8",
    textBg: "#f8f8f8",
    textAlign: "left",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "470px",
    sectionHeight: "540px",
  },
  {
    image: channelManagementStreaming,
    label: "Channel Management & Streaming",
    description:
      "Each NVR hosts multiple channels with unique IDs and statuses. When a channel is online, users can stream live video directly from the channel page or central video interface. This organized setup enables clear monitoring and efficient video access from anywhere in the system.",
    imageLeft: false,
    imageBg: "#ffffff",
    textBg: "#ffffff",
    textAlign: "right",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "650px",
    sectionHeight: "540px",
  },
  {
    image: cameraRecordingControl,
    label: "Camera Recording Control",
    description:
      "Configure individual cameras using main/sub RTSP stream URLs, authentication credentials, and recording settings such as pre/post-event time and retention periods. This allows smart event-based recording with precise control, visible in live view, logs, and reports.",
    imageLeft: true,
    imageBg: "#f8f8f8",
    textBg: "#f8f8f8",
    textAlign: "left",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "540px",
    sectionHeight: "540px",
  },
];

export const NvrContent = () => {
  const { data: products, isLoading: productsLoading } = useSWR(
    "products/",
    fetcher,
  );
  const { isLoggedIn } = useContext(LoginContext);

  return (
    <div className="bg-white w-full">
      <section
        className={`bg-white flex flex-col items-center justify-center gap-6 ${PAGE_X} pt-28 sm:pt-24 min-h-[258px] text-center`}
      >
        <h1 className="text-black text-[32px] font-medium font-['Inter'] leading-normal max-w-[1004px]">
          Intelligent Video Surveillance Management
        </h1>
        <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal max-w-[872px]">
          Simplify NVR integration, live video monitoring, and event-based camera
          recording with scalable and centralized surveillance control.
        </p>
      </section>

      <div className="w-full bg-white mt-6">
        {sections.map((section) => (
          <SectionBlock key={section.label} {...section} />
        ))}
      </div>

      {isLoggedIn && (
        <div className={` mx-auto `}>
          <DownloadSection
            title="Cut Sheet"
            backgroundColor="#FFF"
            description="Learn about Video Integration features"
            backgroundImage={CatalogueBackground}
            buttonText="Download Now"
            linkField="others_link"
            products={products || []}
            isLoading={productsLoading}
            showOnlyFirst={true}
          />
        </div>
      )}
    </div>
  );
};

export default NvrContent;
